export const ERROR_SIGNING= 'error when signing';
export const TRANSACTION_CANCELLED = 'Transaction cancelled';
export const ERROR_SIGNING_TX = 'error signing transaction';
export const PROVIDER_NOT_INTIALIZED = 'provider not intialized';
export const MISSING_PROVIDER_MESSAGE = 'You need a signer/valid signer to send a transaction,use either WalletProvider, LedgerProvider or WalletConnect';
